import {Directive, ElementRef, Host, Input, OnDestroy, OnInit, Renderer2, SkipSelf} from '@angular/core';
import {AbstractControl, ControlContainer} from '@angular/forms';
import {Subscription} from 'rxjs';

@Directive({
  selector: '[utilsMarkRequired]'
})
export class MarkRequiredDirective implements OnInit, OnDestroy {

  @Input()
  public formControlName: string;
  private subscription: Subscription;

  constructor(private readonly render: Renderer2,
              private readonly elementRef: ElementRef,
              @Host() @SkipSelf() private readonly controlContainer: ControlContainer) {
  }

  public ngOnInit(): void {
    if (!this.controlContainer) {
      return;
    }

    const control = this.controlContainer.control.get(this.formControlName);
    if (control) {
      this.subscription = control.statusChanges.subscribe(() => this.onStatusChanged(control));
      this.onStatusChanged(control);
    }
  }

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private onStatusChanged(control: AbstractControl): void {
    const isRequired = control.hasError('required');
    if (isRequired) {
      this.render.addClass(this.elementRef.nativeElement, 'required');
    } else {
      this.render.removeClass(this.elementRef.nativeElement, 'required');
    }
  }
}
